import { Stack, Typography } from '@mui/material'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { QuoteIcon } from './components/QuoteIcon/QuoteIcon'

export const Testimonials = () => {
  const { t } = useTranslation()

  return (
    <Stack
      bgcolor="primary.main"
      sx={(theme) => ({
        display: 'none',
        [theme.breakpoints.up('mobile')]: {
          flex: 1,
          display: 'flex',
          maxWidth: '800px',
        },
      })}
    >
      <Stack
        sx={(theme) => ({
          flex: 1,
          width: '467px',
          alignSelf: 'center',
          padding: '125px 72px',
          gap: theme.spacing(3.5),
          justifyContent: 'center',
          color: theme.palette.common.white,
        })}
      >
        <Typography variant="subtitle1" align="center">
          {t('onboarding::product::testimonials::title')}
        </Typography>
        <Stack
          p={4}
          gap={3}
          sx={{
            position: 'relative',
            borderRadius: '44px',
            border: '1px solid #CAF158',
          }}
        >
          <QuoteIcon
            sx={{
              top: '-20px',
              left: '30px',
              position: 'absolute',
            }}
          />
          <Typography>{t('onboarding::product::testimonials::higherdose::quote')}</Typography>
          <Stack direction="row" gap={2}>
            <Image
              width={74}
              height={74}
              alt="Higherdose cap"
              style={{ borderRadius: '20px' }}
              src="/assets/higherdose-cap.png"
            />
            <Stack>
              <Typography variant="body2" sx={{ color: '#CAF158' }}>
                {t('onboarding::product::testimonials::higherdose::person')}
              </Typography>
              <Typography variant="body2" mb={1}>
                {t('onboarding::product::testimonials::higherdose::position')}
              </Typography>
              <Image alt="Higherdose logo" src="/assets/logos/higherdose.svg" width={122} height={17} />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
